import React, { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import "../../../Assets/Css/AddUpdateInvoice.scss";
import "react-toastify/dist/ReactToastify.css";
import { customStyle } from "../../../Components/Style";
import "../../../Assets/Css/AddUpdateShareHolder.scss";
import Select from "react-select";
import { Spinner } from 'react-bootstrap';
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { useFormik } from "formik";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import moment from "moment";
import { addLeave, updateLeave } from "../../../Services/Leave/action";
import { getUsers } from "../../../Services/Users/action";
import DatePicker from "react-datepicker";
import Swal from "sweetalert2";

const fullDayOptions = [
    { value: "full", label: "Full Day" },
    { value: "firstHalf", label: "First Half" },
    { value: "secondHalf", label: "Second Half" }
];

const multiDayOptions = [
    { value: "fullDays", label: "Full Days" },
    { value: "firstDaySecondHalf", label: "First Day (Second Half)" },
    { value: "lastDayFirstHalf", label: "Last Day (First Half)" }
];
const restrictedOptions = ["firstDaySecondHalf", "lastDayFirstHalf"];
const fullDaysValue = "fullDays";
const AddUpdateLeave = (props) => {
    const location = useLocation();
    const navigate = useNavigate();
    const [selectedMultipleDates, setSelectedMultipleDates] = useState([]);
    const [selectedLeaveMode, setSelectedLeaveMode] = useState(null);
    const { employeeId } = useParams();

    const isSameDay = (() => {
        const [start, end] = selectedMultipleDates;
        if (start && !end) {
            return true;
        }
        if (start && end && moment(start).isSame(moment(end), 'day')) {
            return true;
        }
        return false;
    })();
    const data = location?.state?.data?.allData;

    let leaveTypeOptions;
    leaveTypeOptions = parseFloat(props?.users?.find(item => item?.id == employeeId)?.casual_leave || 0) > 0 ? [
        { value: "Casual", label: "Casual" },
        { value: "Unpaid", label: "Unpaid" },
        // { value: "Earned", label: "Earned" }
    ] : [
        { value: "Unpaid", label: "Unpaid" },
        // { value: "Earned", label: "Earned" }
    ]

    const [selectFilters, setSelectedFilters] = useState({
        date: data?.leave_date || "",
        status: [],
        type: leaveTypeOptions?.find(item => item?.value == data?.type) || [],

    });

    const [fileLinks, setFileLinks] = useState([]);

    useEffect(() => {
        fetchAllData()
    }, []);

    useEffect(() => {
        const storedFiles = JSON.parse(localStorage.getItem('fileLinks')) || [];
        setFileLinks(storedFiles);
    }, []);

    useEffect(() => {
        localStorage.setItem('fileLinks', JSON.stringify(fileLinks));
    }, [fileLinks]);


    const fetchAllData = async () => {
        try {
            await props.getUsers();
        } catch (error) {
            console.error(error);
        }
    }

    const handleRadioBtnChange = (event) => {
        setSelectedDuration(event.target.value);
    };


    let initalVal = {
        user_name: data ? props?.users?.filter(item => item?.id == data?.employee_id)?.map(user => user?.name)[0] : props?.users?.filter(item => item?.id == employeeId)?.map(user => user?.name)[0] || "",
        reason: data?.reason || "",
    };

    const validateForm = () => {
        const isEmployee = props?.user?.role?.name === 'employee';
        const userName = isEmployee ? props?.user?.name : selectFilters?.employee?.label;
        if (
            !selectFilters?.type || !selectFilters.type?.value ||
            !selectedMultipleDates || selectedMultipleDates.length === 0 || !selectedMultipleDates[0] ||
            !selectedLeaveMode || (Array.isArray(selectedLeaveMode) && selectedLeaveMode.length === 0) ||
            !values?.reason || values.reason.trim() === '') {
            toast.error('All fields are required');
            return false;
        }
        return true;
    };


const handleOnSubmit = async () => {
    if (!validateForm()) {
        return;
    }
    try {
        let selectedDates = [];

        const [start, end] = selectedMultipleDates;

        const startDate = moment(start);
        const endDate = end ? moment(end) : moment(start);

        const dates = [];
        let current = startDate.clone();
        while (current.isSameOrBefore(endDate)) {
            dates.push(current.format("YYYY-MM-DD"));
            current.add(1, 'day');
        }
        selectedDates = dates;
        const calculateActualLeaveCount = () => {
            const totalDates = selectedDates.length;
            
            if (totalDates === 1) {
                if (selectedLeaveMode?.value === "full") {
                    return 1;
                } else if (selectedLeaveMode?.value === "firstHalf" || selectedLeaveMode?.value === "secondHalf") {
                    return 0.5;
                }
                return 1;
            } else {
                let totalLeaveCount = 0;
                
                if (Array.isArray(selectedLeaveMode)) {
                    const selectedValues = selectedLeaveMode.map(option => option.value);
                    
                    if (selectedValues.includes("fullDays")) {
                        totalLeaveCount = totalDates;
                    } else {
                        let baseCount = totalDates; 
                        
                        if (selectedValues.includes("firstDaySecondHalf")) {
                            baseCount -= 0.5;
                        }
                        
                        if (selectedValues.includes("lastDayFirstHalf")) {
                            baseCount -= 0.5;
                        }
                        
                        totalLeaveCount = baseCount;
                    }
                } else if (selectedLeaveMode?.value) {
                    const selectedValue = selectedLeaveMode.value;
                    
                    if (selectedValue === "fullDays") {
                        totalLeaveCount = totalDates;
                    } else if (selectedValue === "firstDaySecondHalf") {
                        totalLeaveCount = 0.5 + (totalDates - 1);
                    } else if (selectedValue === "lastDayFirstHalf") {
                        totalLeaveCount = (totalDates - 1) + 0.5;
                    } else if (selectedValue === "full") {
                        totalLeaveCount = totalDates;
                    } else {
                        totalLeaveCount = totalDates;
                    }
                } else {
                    totalLeaveCount = totalDates;
                }
                
                return totalLeaveCount;
            }
        };

        const actualLeaveCount = calculateActualLeaveCount();

        let availableCasualLeave = parseFloat(props?.users?.find(item => item?.id == employeeId)?.casual_leave || 0);
        let originalCasualLeaveCount = 0;
        if (data) {
            if (data.casual) {
                originalCasualLeaveCount = parseFloat(data.casual) || 0;
            }
        }

        let effectiveAvailableCasual = availableCasualLeave + originalCasualLeaveCount;
        let showAvailableCasualLeave = data ? effectiveAvailableCasual : availableCasualLeave;

        const body = {
            employee_id: employeeId,
            reason: values.reason,
            type: selectFilters?.type?.value,
            start_date: selectedDates[0],
            end_date: end ? selectedDates[selectedDates.length - 1] : selectedDates[0],
            duration: Array.isArray(selectedLeaveMode)
                ? selectedLeaveMode.map((option) => option.value).join(',')
                : selectedLeaveMode?.value,
            updateLocalUser: false
        }

        const proceedWithLeave = async () => {
            if (data) {
                await props?.updateLeave(data?.id, body, navigate);
            } else {
                await props?.addLeave({ ...body, status: 'Pending' }, navigate);
            }
        };

        if (selectFilters?.type?.value === "Casual" && actualLeaveCount > effectiveAvailableCasual) {
            const unpaidCount = actualLeaveCount - effectiveAvailableCasual;

            Swal.fire({
                title: 'Leave Limit Exceeded',
                html: `You have only <b>${showAvailableCasualLeave}</b> casual leaves.<br/><b>${unpaidCount}</b> of the selected leave(s) will be treated as <b>Unpaid</b>.<br/><br/>Do you want to proceed?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, Proceed',
                cancelButtonText: 'Cancel',
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
            }).then(async (result) => {
                if (result.isConfirmed) {
                    await proceedWithLeave();
                }
            });
        } else {
            Swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, Apply',
            }).then(async (result) => {
                if (result.isConfirmed) {
                    await proceedWithLeave();
                }
            });
        }
    } catch (error) {
        console.error("Error in adding leave :", error);
    }
}

    let { values, errors, touched, handleChange, handleSubmit } = useFormik({
        initialValues: initalVal,
        enableReinitialize: true,
        onSubmit: handleOnSubmit
    });

    return (
        <div className="addUpdateShareholder-main">
            <div className="page-title">
                <h4>Assign Leave</h4>
                <div className="edit-btn">
                    <button
                        type="submit"
                        className="custom-btn"
                        onClick={() => navigate(-1)}
                    >Cancel
                    </button>

                    <button
                        type="submit"
                        className="custom-btn"
                        onClick={handleSubmit}
                    >
                        {props.loading ? (
                            <Spinner
                                as="span"
                                animation="border"
                                className="custom-spinner"
                                role="status"
                                aria-hidden="true"
                            />
                        ) : (
                            'Save'
                        )}
                    </button>
                </div>
            </div>

            <div className="content-part">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="leave-card">
                            <div className="custom-row">
                                <div className="row">
                                    {/* name */}
                                    <div className="col-lg-4 col-md-6">
                                        <div className="input-group">
                                            <h6 className="label">Name <span className='required-field'> *</span></h6>
                                            <input
                                                disabled={values?.user_name ? true : false}
                                                type="text"
                                                value={values.user_name}
                                                name="seller_name"
                                                onChange={handleChange}
                                                className="input-css"
                                            />
                                            {errors.user_name && touched.user_name ? (
                                                <p className="error-text">{errors.user_name}</p>
                                            ) : null}
                                        </div>
                                    </div>

                                    {/* leave type */}
                                    <div className="col-lg-4 col-md-6">
                                        <div className="input-group">
                                            <div className="label">Leave Type <span className='required-field'> *</span></div>
                                            <Select
                                                value={selectFilters.type}
                                                onChange={(data) =>
                                                    setSelectedFilters({ ...selectFilters, type: data })
                                                }
                                                options={leaveTypeOptions}
                                                placeholder={"--"}
                                                styles={customStyle}
                                                theme={(theme) => ({
                                                    ...theme,
                                                    colors: {
                                                        ...theme.colors,
                                                        primary25: "#5757fe",
                                                        primary: "#5757fe",
                                                    },
                                                })}
                                            />
                                        </div>
                                    </div>

                                    {/* duration */}
                                    <div className="col-lg-4 col-md-6"></div>

                                    <div className="col-lg-4 col-md-6">
                                        <div className="input-group">
                                            <div className="label">Date <span className='required-field'> *</span></div>
                                            <DatePicker
                                                selectsRange
                                                selected={selectedMultipleDates[0]}
                                                startDate={selectedMultipleDates[0]}
                                                endDate={selectedMultipleDates[selectedMultipleDates.length - 1]}
                                                placeholderText="Select Dates"
                                                onChange={(dates) => {
                                                    setSelectedMultipleDates(dates);
                                                }}
                                                disabled={props.loading}
                                                dateFormat="dd-MM-yyyy"
                                                maxDate={moment().add(2, 'months').toDate()}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-lg-4 col-md-6">
                                        <div className="input-group">
                                            <div className="label">Leave Duration <span className='required-field'> *</span></div>
                                            <Select
                                                value={selectedLeaveMode}
                                                onChange={(option) => setSelectedLeaveMode(option)}
                                                options={isSameDay ? fullDayOptions : multiDayOptions}
                                                placeholder="Select Duration"
                                                isMulti={!isSameDay}
                                                styles={customStyle}
                                                isDisabled={selectedMultipleDates.length < 1}
                                                isOptionDisabled={(option) => {
                                                    if (!isSameDay && Array.isArray(selectedLeaveMode)) {
                                                        const values = selectedLeaveMode.map((opt) => opt.value);
                                                        const isFullDaysSelected = values.includes(fullDaysValue);
                                                        const isRestrictedSelected = restrictedOptions.some(val => values.includes(val));

                                                        if (isFullDaysSelected && restrictedOptions.includes(option.value)) {
                                                            return true;
                                                        }
                                                        if (isRestrictedSelected && option.value === fullDaysValue) {
                                                            return true;
                                                        }
                                                    }
                                                    return false;
                                                }}
                                                theme={(theme) => ({
                                                    ...theme,
                                                    colors: {
                                                        ...theme.colors,
                                                        primary25: "#5757fe",
                                                        primary: "#5757fe",
                                                    },
                                                })}
                                            />
                                        </div>
                                    </div>

                                    {/* */}
                                    <div className="col-lg-4 col-md-6">
                                        <div className="input-group">
                                        </div>
                                    </div>

                                    {/* reason */}
                                    <div className="col-lg-12 col-md-12">
                                        <div className="input-group">
                                            <div className="label">Reason <span className='required-field'> *</span></div>
                                            <textarea className="form-control" style={{ width: "100%" }} name="reason" value={values.reason} placeholder="e.g. Feeling not well." onChange={handleChange} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        loading: state.leaveReducer.loading,
        users: state.userReducer.users
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        addLeave: (data, navigate) => {
            dispatch(addLeave(data, navigate))
        },
        updateLeave: (id, data, navigate) => {
            dispatch(updateLeave(id, data, navigate))
        },
        getUsers: () => {
            dispatch(getUsers())
        }
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(AddUpdateLeave);
